import { defineRoutes } from '#utils';

export const routes = defineRoutes(
  {
    cohorts: {
      create: '/cohorts',
      find: '/cohorts',
      get: (id: string) => `/cohorts/${id}`,
      patch: (id: string) => `/cohorts/${id}`,
      remove: (id: string) => `/cohorts/${id}`,
    },
    medicalGroups: {
      create: '/medical-groups',
      find: '/medical-groups',
      get: (id: string) => `/medical-groups/${id}`,
      patch: (id: string) => `/medical-groups/${id}`,
    },
    patients: {
      find: '/patients',
      memberships: {
        batch: {
          create: '/patients/memberships/batch',
          remove: '/patients/memberships/batch',
        },
      },
    },
  },
  { exactKeys: ['medicalGroups'] },
);
